import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const eyebrowFn = /* @__PURE__ */ createRecipe('eyebrow', {
  "size": "sm"
}, [])

const eyebrowVariantMap = {
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "tone": [
    "neutral",
    "primary",
    "secondary",
    "inverse",
    "warm"
  ]
}

const eyebrowVariantKeys = Object.keys(eyebrowVariantMap)

export const eyebrow = /* @__PURE__ */ Object.assign(memo(eyebrowFn.recipeFn), {
  __recipe__: true,
  __name__: 'eyebrow',
  __getCompoundVariantCss__: eyebrowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: eyebrowVariantKeys,
  variantMap: eyebrowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, eyebrowVariantKeys)
  },
  getVariantProps: eyebrowFn.getVariantProps,
})